<div class="radio" [attr.tabIndex]="disabled ? null : '0'" (focus)="onFocusInput()" (blur)="onBlurInput()"
[ngClass]="{'checked': checked }" id="{{label}}"></div>
@if (label) {
  <div class="label" [ngClass]="{'small': small }">{{label}}</div>
}